// extracted by mini-css-extract-plugin
export default {"accordionSummary":"NavSection_accordionSummary__V72CR","accordion":"NavSection_accordion__wU0ff","accordionDetails":"NavSection_accordionDetails__v3hxE"};